import React, { PropsWithChildren } from 'react';
import {
  Tab,
  Icon,
  HStack,
  Text,
  Center,
  Tooltip,
} from '@wegroup/design-system';

interface Props {
  isComplete: boolean;
  isDisabled?: boolean;
  disabledTooltip?: string;
}

const LanguageTab: React.FC<PropsWithChildren<Props>> = ({
  isComplete,
  isDisabled = false,
  disabledTooltip,
  children,
}) => {
  const tabContent = (
    <Tab mx="0" isDisabled={isDisabled}>
      <HStack spacing="2" px="1" opacity={isDisabled ? 0.5 : 1}>
        <Center
          color={isComplete ? 'success.main' : 'warning.main'}
          border="1px"
          borderRadius="full"
        >
          <Icon
            name={
              isComplete
                ? 'GeneralStatusSuccessCheckmark'
                : 'GeneralActionsCloseOrRemove'
            }
            boxSize="3"
          />
        </Center>
        <Text color={isDisabled ? 'gray.400' : 'inherit'}>{children}</Text>
      </HStack>
    </Tab>
  );

  if (isDisabled && disabledTooltip) {
    return (
      <Tooltip label={disabledTooltip} placement="top">
        {tabContent}
      </Tooltip>
    );
  }

  return tabContent;
};

export default LanguageTab;
